import { debugInfo } from '@vfde-sails/utils';
import {
    PageViewTrackingData,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';
import {
    getTrackingBase,
    getTrackingOrderObject,
} from './util';
import { AppState } from '../container/App/interface';

/**
 * General pageview tracking event
 */
export const trackPageview = (state: AppState) => {
    try {
        const payload: PageViewTrackingData = {
            ...getTrackingBase(state),
            oOrder: getTrackingOrderObject(state),
        };

        trackIt(TrackType.PageView, payload);
        debugInfo('Track pageview: ', payload);
    }
    catch (error) {
        debugInfo('Error during pageview tracking: ', error);
    }
};
